//Product Images Swiper
window.addEventListener("load", function () {
  var swiper = new Swiper(".product-swiper", {
    autoHeight: true,
    //loop: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });
});

//Waitlist Button / Form
let waitBtn = document.querySelector('.waitlist-btn');
let waitForm = document.querySelector('.waitlist-form');

if(waitBtn){
  let waitSubmit = document.querySelector('#wait-submit');
  let waitInputs = waitForm.querySelector('form');
  let waitConfirm = waitForm.querySelector('.confirm');
  let waitError = waitForm.querySelector('.error');
  let waitLink = document.querySelector('#wait-link');
  let waitPName = waitLink.dataset.product;
  let waitPId = waitLink.dataset.id;

  waitBtn.addEventListener('click', function(event){
    event.preventDefault();
    waitForm.classList.toggle('active');
    waitForm.querySelector('input').focus();
  });
  
  waitSubmit.addEventListener('click', function(event){
    event.preventDefault();
  
    let waitEmail = waitForm.querySelector('.customer-email').value;
    let waitName = waitForm.querySelector(".customer-name").value;
  
    let emailSign = waitEmail.includes("@");
    let emailCheck = false;
    let emailName = false
  
    if(waitEmail != ""){
      emailCheck = true;
    }
  
    if(waitName != "") {
      emailName = true;
    }
  
    if(emailCheck && emailSign && emailName){
      waitError.classList.remove("show");
      waitConfirm.classList.add('show');
      waitInputs.classList.toggle("hide");
  
      let mailLink = "mailto:victoriamorrispottery@gmail.com?subject=Inquiry - " + waitPName + 
  "&body=My%20name%20is%20" + waitName + 
  ".%20I%20would%20like%20to%20inquire%20about%20" + waitPName + 
  ".%20You%20can%20reach%20me%20at%20" + waitEmail + 
  ".%0D%0A%0D%0AProduct%20ID:%20" + waitPId + 
  "%0D%0AQuantity:%201";

    


      waitLink.setAttribute('href', mailLink);
      waitLink.click();
  
  
    } else {
      
      waitError.classList.add('show');
    }
  
  });
}

let atcBtn = document.querySelector('.atc-btn');

if(atcBtn){
  let id = atcBtn.dataset.variantId;
  let policy = atcBtn.dataset.sellingPolicy;
  let inventory = parseInt(atcBtn.dataset.inventory);

  atcBtn.addEventListener('click', function(event){
    event.preventDefault();
    console.log("Add to cart clicked for variant ID: " + id + " with policy: " + policy);
    let leadTime = atcBtn.dataset.leadTime;
    if(leadTime != ""){
      leadTime = "Ships in " + leadTime + " weeks";
    } 
    if(policy == "continue" && inventory <= 0){
      CartJS.addItem(id, 1, {
        "Made To Order": leadTime,
      });
    } else {
      CartJS.addItem(id, 1);
    }
  });
}